import { useState } from 'react';

interface AccordionProps {
  title: string;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

function AccordionComponent({ title, defaultOpen = false, children }: AccordionProps) {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="border-t pt-4">
      <button
        className="w-full flex justify-between items-center"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{title}</span>
        <span>{isOpen ? '−' : '+'}</span>
      </button>
      
      {isOpen && (
        <div className="mt-4 space-y-4">
          {children}
        </div>
      )}
    </div>
  );
}

// Definisci Item come componente separato
const AccordionItem = ({ children }: { children: React.ReactNode }) => (
  <div className="py-2">{children}</div>
);

// Assegna Item come proprietà statica
AccordionComponent.Item = AccordionItem;

export default AccordionComponent; 